/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const HomeAlt = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M12.5074 4.01167L21.4997 12.0589L22.5 10.9411L13.5077 2.8939C12.6516 2.12782 11.356 2.12965 10.5021 2.89814L1.50269 10.9976L2.50613 12.1125L11.5055 4.01309C11.7902 3.75692 12.2221 3.75631 12.5074 4.01167ZM4.99989 20.5V12H3.49989V20.5C3.49989 21.3284 4.17147 22 4.99989 22H10.4999V16.5C10.4999 15.9477 10.9476 15.5 11.4999 15.5H12.4999C13.0522 15.5 13.4999 15.9477 13.4999 16.5V22H18.9999C19.8283 22 20.4999 21.3284 20.4999 20.5V12H18.9999V20.5H14.9999V16C14.9999 14.75 14.2499 14 12.9999 14H10.9999C9.74989 14 8.99989 14.75 8.99989 16V20.5H4.99989Z"
                        fill={color}
                    />
                </svg>
        );
    };
